import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { receiveRoute } from '@m/cabinet/components/views/utils'
import Receive from '@m/cabinet/components/views/Receive.vue'
import { getFacility } from '@/services/facility.service'

import {
  GENERAL_TAB_KEY,
  DOCUMENTS_TAB_KEY,
  COORDINATOR_TAB_KEY,
  REQUISITES_TAB_KEY,
  SERVICES_TAB_KEY,
  DOCTORS_TAB_KEY,
  MEDIA_TAB_KEY,
  SCHEDULE_TAB_KEY,
  MODERATION_TAB_KEY,
  PUBLICATION_TAB_KEY,
  FACILITY_TABS_TITLES,
} from './const'

const FACILITY_PREFIX = 'cabinet:facility'
const SERVICE_PREFIX = 'service'
const DOCTOR_PREFIX = 'doctor'
const p = (name: string) => FACILITY_PREFIX + ':' + name
const ps = (name: string) => FACILITY_PREFIX + ':' + SERVICE_PREFIX + ':' + name
const pd = (name: string) => FACILITY_PREFIX + ':' + DOCTOR_PREFIX + ':' + name

export const FACILITY_VIEW_NAME = p('view')
export const FACILITY_CREATE_VIEW_NAME = p('create')
export const FACILITY_SINGLE_CREATE_VIEW_NAME = p('single-create')
export const FACILITY_GENERAL_VIEW_NAME = p(GENERAL_TAB_KEY)
export const FACILITY_DOCUMENTS_VIEW_NAME = p(DOCUMENTS_TAB_KEY)
export const FACILITY_COORDINATOR_VIEW_NAME = p(COORDINATOR_TAB_KEY)
export const FACILITY_REQUISITES_VIEW_NAME = p(REQUISITES_TAB_KEY)
export const FACILITY_SERVICES_VIEW_NAME = p(SERVICES_TAB_KEY)
export const FACILITY_DOCTORS_VIEW_NAME = p(DOCTORS_TAB_KEY)
export const FACILITY_MEDIA_VIEW_NAME = p(MEDIA_TAB_KEY)
export const FACILITY_SCHEDULE_VIEW_NAME = p(SCHEDULE_TAB_KEY)
export const FACILITY_MODERATION_VIEW_NAME = p(MODERATION_TAB_KEY)
export const FACILITY_PUBLICATION_VIEW_NAME = p(PUBLICATION_TAB_KEY)

export const FACILITY_SERVICE_CREATE = ps('create')
export const FACILITY_SERVICE_EDIT = ps('edit')
export const FACILITY_SERVICE_IMPORT = ps('import')

export const FACILITY_SERVICE_GENERAL_NAME = ps('general')
export const FACILITY_SERVICE_ADDITIONAL_NAME = ps('additional')
export const FACILITY_SERVICE_DESCRIPTION_NAME = ps('description')
export const FACILITY_SERVICE_DOCTORS_NAME = ps('doctors')

export const FACILITY_DOCTOR_EDIT = pd('edit')
export const FACILITY_DOCTOR_VIEW_NAME = pd('view')
export const FACILITY_DOCTOR_SERVICES_NAME = pd('services')

const View = () => import('@m/cabinet/modules/Facility/views/View.vue')
const Create = () => import('@m/cabinet/modules/Facility/views/Create.vue')

const ServicesImports = () =>
  import('@m/cabinet/modules/Facility/views/ServicesImports.vue')
const General = () => import('@m/cabinet/modules/Facility/tabs/General.vue')
const Documents = () => import('@m/cabinet/modules/Facility/tabs/Documents.vue')
const Requisites = () =>
  import('@m/cabinet/modules/Facility/tabs/Requisites.vue')
const Coordinators = () =>
  import('@m/cabinet/modules/Facility/tabs/Coordinators.vue')
const Services = () => import('@m/cabinet/modules/Facility/tabs/Services.vue')
const Doctors = () => import('@m/cabinet/modules/Facility/tabs/Doctors.vue')
const Media = () => import('@m/cabinet/modules/Facility/tabs/Media.vue')
// const Schedule = () => import('@m/cabinet/modules/Facility/tabs/Schedule.vue')
const Moderation = () =>
  import('@m/cabinet/modules/Facility/tabs/Moderation.vue')
const Publication = () =>
  import('@m/cabinet/modules/Facility/tabs/Publication.vue')


const ServiceCreate = () =>
  import('@m/cabinet/modules/Facility/views/ServiceCreate.vue')
const ServiceView = () =>
  import('@m/cabinet/modules/Facility/views/ServiceView.vue')
const ServiceFormGeneral = () =>
  import('@m/cabinet/modules/Facility/tabs/service/ServiceFormGeneral.vue')
const ServiceFormAdditional = () =>
  import('@m/cabinet/modules/Facility/tabs/service/ServiceFormAdditional.vue')
const ServiceFormDescription = () =>
  import('@m/cabinet/modules/Facility/tabs/service/ServiceFormDescription.vue')
const ServiceFormDoctors = () =>
  import('@m/cabinet/modules/Facility/tabs/service/ServiceFormDoctors.vue')

const DoctorView = () =>
  import('@m/cabinet/modules/Facility/views/DoctorView.vue')
const DoctorServices = import(
  '@m/cabinet/modules/Facility/tabs/doctor/DoctorServices.vue'
)

const BASE_MODEL_NAME = 'facility/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    route('create/', Create, FACILITY_SINGLE_CREATE_VIEW_NAME, {
      meta: {
        // title: () => FACILITY_TABS_TITLES[GENERAL_TAB_KEY],
        key: GENERAL_TAB_KEY,
        // fallbackRouteName: FACILITY_GENERAL_VIEW_NAME,
        isHideCabinetHead: true,
      },
    }),
    prefixRoutes(
      ':chainId/',
      [
        //   route(':chain/', View, FACILITY_VIEW_NAME, {
        //     children: [],
        //   }),
        //   route('create/', Create,  FACILITY_CREATE_VIEW_NAME, {}),

        route('create/', Create, FACILITY_CREATE_VIEW_NAME, {
          meta: {
            // title: () => FACILITY_TABS_TITLES[GENERAL_TAB_KEY],
            key: GENERAL_TAB_KEY,
            // fallbackRouteName: FACILITY_GENERAL_VIEW_NAME,
            // isContainered: true,
            isHideCabinetHead: true,
          },
        }),
        {
          name: FACILITY_VIEW_NAME,
          redirect: { name: FACILITY_GENERAL_VIEW_NAME },
          ...(receiveRoute(
            getFacility,
            [
              prefixRoutes(
                '',
                [
                  route('general/', General, FACILITY_GENERAL_VIEW_NAME, {
                    meta: {
                      title: () => FACILITY_TABS_TITLES[GENERAL_TAB_KEY],
                      key: GENERAL_TAB_KEY,
                      isHideCabinetHead: true,
                      // isContainered: true,
                    },
                  }),
                  prefixRoutes(
                    'services/',
                    [
                      route(
                        'import/',
                        ServicesImports,
                        FACILITY_SERVICE_IMPORT,
                        {
                          meta: {
                            title: () => $t('Import services'),
                            fallbackRouteName: {
                              name: FACILITY_SERVICES_VIEW_NAME,
                              text: $t('Back to the services list'),
                            },
                          },
                        }
                      ),
                      route('', Services, FACILITY_SERVICES_VIEW_NAME, {
                        meta: {
                          title: () => FACILITY_TABS_TITLES[SERVICES_TAB_KEY],
                          key: SERVICES_TAB_KEY,
                        },
                      }),
                    ],
                    {
                      meta: {
                        title: () => FACILITY_TABS_TITLES[SERVICES_TAB_KEY],
                        key: SERVICES_TAB_KEY,
                        isHideCabinetHead: true,
                      },
                    }
                  ),

                  route('documents/', Documents, FACILITY_DOCUMENTS_VIEW_NAME, {
                    meta: {
                      title: () => FACILITY_TABS_TITLES[DOCUMENTS_TAB_KEY],
                      key: DOCUMENTS_TAB_KEY,
                      isHideCabinetHead: true,
                      // isContainered: true,
                    },
                  }),
                  route(
                    'requisites/',
                    Requisites,
                    FACILITY_REQUISITES_VIEW_NAME,
                    {
                      meta: {
                        title: () => FACILITY_TABS_TITLES[REQUISITES_TAB_KEY],
                        key: REQUISITES_TAB_KEY,
                        isHideCabinetHead: true,
                        // isContainered: true,
                      },
                    }
                  ),
                  route(
                    'coordinator/',
                    Coordinators,
                    FACILITY_COORDINATOR_VIEW_NAME,
                    {
                      meta: {
                        title: () => FACILITY_TABS_TITLES[COORDINATOR_TAB_KEY],
                        key: COORDINATOR_TAB_KEY,
                        isHideCabinetHead: true,
                        // isContainered: true,
                      },
                    }
                  ),
                  route('doctors/', Doctors, FACILITY_DOCTORS_VIEW_NAME, {
                    meta: {
                      title: () => FACILITY_TABS_TITLES[DOCTORS_TAB_KEY],
                      key: DOCTORS_TAB_KEY,
                      isHideCabinetHead: true,
                    },
                  }),
                  route('media/', Media, FACILITY_MEDIA_VIEW_NAME, {
                    meta: {
                      title: () =>FACILITY_TABS_TITLES[MEDIA_TAB_KEY],
                      key: MEDIA_TAB_KEY,
                      isHideCabinetHead: true,
                      // isContainered: true,
                    },
                  }),
                  // route('schedule/', Schedule, FACILITY_SCHEDULE_VIEW_NAME, {
                  //   meta: {
                  //     title: () => FACILITY_TABS_TITLES[SCHEDULE_TAB_KEY],
                  //     key: SCHEDULE_TAB_KEY,
                  //     isHideCabinetHead: true,
                  //   },
                  // }),
                  route('moderation/', Moderation, FACILITY_MODERATION_VIEW_NAME, {
                    meta: {
                      title: () => FACILITY_TABS_TITLES[MODERATION_TAB_KEY],
                      key: MODERATION_TAB_KEY,
                      isHideCabinetHead: true,
                    },
                  }),
                  route('publication/', Publication, FACILITY_PUBLICATION_VIEW_NAME, {
                    meta: {
                      title: () => FACILITY_TABS_TITLES[PUBLICATION_TAB_KEY],
                      key: PUBLICATION_TAB_KEY,
                      isHideCabinetHead: true,
                    },
                  }),
                ],
                {
                  name: FACILITY_VIEW_NAME,
                  redirect: { name: FACILITY_GENERAL_VIEW_NAME },
                  meta: {},
                  component: View,
                  props: {
                    resource: getFacility,
                    resourceKey: 'id',
                    routeKey: 'facility',
                  },
                }
              ),
              prefixRoutes('services/', [
                route('create/', ServiceCreate, FACILITY_SERVICE_CREATE, {
                  meta: {
                    title: () => $t('Create service'),
                    fallbackRouteName: {
                      name: FACILITY_SERVICES_VIEW_NAME,
                      text: $t('Back to the services list'),
                    },
                  },
                }),
                route(':id/', ServiceView, FACILITY_SERVICE_EDIT, {
                  meta: {
                    title: () => $t('&nbsp;'),
                    fallbackRouteName: {
                      name: FACILITY_SERVICES_VIEW_NAME,
                      text: $t('Back to the services list'),
                    },
                  },
                  redirect: (to) => ({
                    name: FACILITY_SERVICE_GENERAL_NAME,
                    params: to.params,
                  }),
                  children: [
                    route(
                      'general/',
                      ServiceFormGeneral,
                      FACILITY_SERVICE_GENERAL_NAME,
                      options
                    ),
                    route(
                      'additional/',
                      ServiceFormAdditional,
                      FACILITY_SERVICE_ADDITIONAL_NAME,
                      options
                    ),
                    route(
                      'description/',
                      ServiceFormDescription,
                      FACILITY_SERVICE_DESCRIPTION_NAME,
                      options
                    ),
                    route(
                      'doctors/',
                      ServiceFormDoctors,
                      FACILITY_SERVICE_DOCTORS_NAME,
                      options
                    ),
                    route('', ServiceView, FACILITY_SERVICE_EDIT, {
                      redirect: (to) => ({
                        name: FACILITY_SERVICE_GENERAL_NAME,
                        params: to.params,
                      }),
                    }),
                  ],
                }),
              ]),
              prefixRoutes('doctor/', [
                // route('create/', ServiceCreate, FACILITY_SERVICE_CREATE, {
                //   meta: {
                //     title: () => $t('Create service'),
                //     fallbackRouteName: {
                //       name: FACILITY_SERVICES_VIEW_NAME,
                //       text: $t('Back to the services list'),
                //     },
                //   },
                // }),
                route(':placeWorkId/', DoctorView, FACILITY_DOCTOR_EDIT, {
                  meta: {
                    title: () => $t('&nbsp;'),
                    fallbackRouteName: {
                      name: FACILITY_DOCTORS_VIEW_NAME,
                      text: $t('Back to the doctors list'),
                    },
                  },
                  children: [
                    route(
                      'services/',
                      DoctorServices,
                      FACILITY_DOCTOR_SERVICES_NAME,
                      options
                    ),
                    // route('', DoctorView, FACILITY_DOCTOR_EDIT, {
                    //   redirect: (to) => ({
                    //     name: FACILITY_DOCTOR_SERVICES_NAME,
                    //     params: to.params,
                    //   }),
                    // }),
                  ],
                  redirect: (to) => ({
                    name: FACILITY_DOCTOR_SERVICES_NAME,
                    params: to.params,
                  }),
                }),
              ]),
            ],
            Receive,
            '',
            'facility',
            'id',
            {}
          ) as any),
        },
      ],
      options
    ),
  ]
}

export { BASE_MODEL_NAME }
